import { useEffect } from "react";

export const logout = () => {
  localStorage.clear();
  window.location.href = '/login';
};

export function validateEmail(email) {
  const emailRegx = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,16})+$/);
  return emailRegx.test(email) !== false;
}

export const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.body.addEventListener("click", handleClick);

    return () => {
      document.body.removeEventListener("click", handleClick);
    };
  });
};

export const tokenExpire = (errorData, navigate) => {
  let status;
  if (errorData === undefined) {
    status = 666;
  } else {
    status = errorData;
  }

  switch (status) {
    // case 401:
    case 401:
      logout();
      navigate("/login");
      break;
    case 666:
      logout();
      navigate("/login");
      break;
    case 403:
      logout();
      navigate("/login");
      break;
    default:
      // Optionally handle other errors without forcing logout
      // console.log(status);
      break;
  }
};

export const isValidFile = (product, file) => {
  // console.log(file, '---file in indexJs');
  const clientData = JSON.parse(localStorage.getItem("clientDetails"));
  switch (product) {
    case "P001":
      if (
        file.name.startsWith(
          `FIRM_${clientData.clientName}_AIFMD_Trading_TxnR_`,
          0,
        ) &&
        file.type === "text/csv"
      ) {
        return true;
      }
      return false;

    case "P002":
      if (
        file.name.startsWith(
          `FIRM_${clientData.clientName}_AIFMD_Holding_TxnR_`,
          0,
        ) &&
        file.type === "text/csv"
      ) {
        return true;
      }
      return false;

    case "P003":
      if (
        file.name.startsWith(
          `FIRM${clientData.clientName}_AIFMD_Trial_Balance_TxnR_`,
          0,
        ) &&
        file.type === "text/csv"
      ) {
        return true;
      }
      return false;

    case "P004":
      const errorFileTextCases = [
        "ERROR",
        "Error",
        "ERRORS",
        "Errors",
        "errors",
        "error",
      ];
      // const originalFileTextCases = ["ORIGINAL", "original", "Original"];
      const processedFileTextCases = ["PROCESSED", "processed", "Processed"];
      const excludedFileTextCases = ["Excluded", "EXCLUDED", "excluded"];
      const ineligibleFileTextCases = [
        "InElig",
        "Ineligible",
        "INELIGIBLE",
        "Ineligible",
      ];
      if (errorFileTextCases.some((text) => file?.name?.includes(text))) {
        return false;
      }
      if (processedFileTextCases.some((text) => file?.name?.includes(text))) {
        return false;
      }
      if (excludedFileTextCases.some((text) => file?.name?.includes(text))) {
        return false;
      }
      if (ineligibleFileTextCases.some((text) => file?.name?.includes(text))) {
        return false;
      }
      return true;
    default:
      break;
  }
};
